<!-- @format -->

@if (data$ | async; as freeEditPlanData) {
  <ng-container *transloco="let t">
    <fudis-dialog class="free-edit-dialog">
      <fudis-heading sisAutofocus [level]="2"
        >{{ t("SIS_COMPONENTS.PLAN.FREE_EDIT.TITLE") + ": " + (this.modalValues.module.name | localizedString) }}
      </fudis-heading>
      <fudis-dialog-content>
        <app-free-edit-course-unit-expandable
          [searchCurriculumPeriods]="freeEditPlanData.searchCurriculumPeriods"
          [allCourseUnits]="freeEditPlanData.allCourseUnits"
          [allCustomCourseUnitAttainments]="freeEditPlanData.allCustomCourseUnitAttainments"
          [unplannedAttainments]="(planStructureData$ | async)?.unplannedAttainments"
          [planData]="freeEditPlanData.planData"
          [planStateObject]="freeEditPlanData.planStateObject"
          [validatablePlan]="freeEditPlanData.validatablePlan"
          (selectedCourseUnit)="selectedCourseUnit($event)"
          (toggledCourseUnit)="handleCourseUnitToggle($event)"
          (toggledCustomCourseUnitAttainment)="handleCustomCourseUnitAttainmentToggle($event)">
        </app-free-edit-course-unit-expandable>
        <app-free-edit-module-expandable
          [allModules]="$any(freeEditPlanData.allModules)"
          [searchCurriculumPeriods]="freeEditPlanData.searchCurriculumPeriods"
          [unplannedAttainments]="(planStructureData$ | async)?.unplannedAttainments"
          [allCustomModuleAttainments]="freeEditPlanData.allCustomModuleAttainments"
          [planData]="freeEditPlanData.planData"
          [planStateObject]="freeEditPlanData.planStateObject"
          [validatablePlan]="freeEditPlanData.validatablePlan"
          (toggleModule)="handleModuleToggle($event)"
          (toggleCustomModule)="handleCustomModuleToggle($event)"
          (selectModule)="selectedModule($event)">
        </app-free-edit-module-expandable>
        @if (!isPlanRootModule) {
          <app-free-edit-custom-study-draft-expandable
            [module]="this.modalValues.module"
            [allCustomStudyDrafts]="freeEditPlanData.allCustomStudyDrafts"
            (openAddStudyDraftModal)="this.openAddStudyDraftModal()"
            (toggleCustomStudyDraft)="this.toggleCustomStudyDraft($event)"
            [validatablePlan]="freeEditPlanData.validatablePlan">
          </app-free-edit-custom-study-draft-expandable>
        }
      </fudis-dialog-content>
      <fudis-dialog-actions>
        <fudis-button fudisDialogClose [label]="t('SIS_COMPONENTS.BUTTON.CANCEL')" (handleClick)="dismiss()" [variant]="'secondary'" />
        <fudis-button [label]="t('SIS_COMPONENTS.BUTTON.SAVE')" (handleClick)="submitClick$.next()" />
      </fudis-dialog-actions>
    </fudis-dialog>
  </ng-container>
}
